import React from 'react';
import { PropTypes } from 'prop-types';
import classNames from 'classnames';
import Select from 'react-select';
import InputFieldBaseHOC from './InputFieldBase';
import Lang from '../language/services/Lang';
import './DropdownBase.scss'

const IndicatorSeparator = ({ innerRef, innerProps }) => (
    <div ref={innerRef} {...innerProps} />
);

const DropdownIndicator = (props) => {
    var { innerRef, innerProps, selectProps } = props;
    return (
        <div ref={innerRef} {...innerProps}>
            <i className={selectProps.menuIsOpen ? "la la-angle-up" : "la la-angle-down"} />
        </div>
    )
};

const Option = (props) => {
    return (
        <div className={classNames('hrb-select-option-container', { 'hrb-select-option-selected': props.isSelected })} ref={props.innerRef} {...props.innerProps}>
            <i className="la la-check" />
            <div className="hrb-select-option-text">
                {props.children}
            </div>
        </div>
    )
};

const DropdownBase = (props) => {
    let { value, propertyName, onChange, lang, options, extraClasses } = props;

    var selectedOption = null
    options.forEach(x => {
        if (x.value === value) {
            selectedOption = x;
        }
    });

    const handleChange = (ev) => {
        options.forEach(x => {
            if (x.value === ev.value) {
                onChange(propertyName, x.value)
            }
        })
    };
    var baseClassName = "hrb-select-container";
    if (extraClasses) {
        baseClassName += ' ' + extraClasses;
    }

    return (
        <Select onChange={handleChange} options={options} defaultValue={selectedOption} className={baseClassName}
            classNamePrefix="hrb-select" isClearable={false} menuPlacement="auto" minMenuHeight={220}
            components={{ IndicatorSeparator, DropdownIndicator, Option }} autoComplete="nope"
            placeholder={Lang.getValue('common.select-placeholder', lang)}  />
    );
}

DropdownBase.propTypes = {
    propertyName: PropTypes.string.isRequired,
    labelKey: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    placeholderKey: PropTypes.string,
    lang: PropTypes.string.isRequired,
    options: PropTypes.arrayOf(PropTypes.shape({
        key: PropTypes.string,
        value: PropTypes.string
    })),
    extraClasses: PropTypes.string
};


export default InputFieldBaseHOC(DropdownBase);
